
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-06 16:08:56
-->
<template>
  <el-drawer
    :title="item.id ? '编辑站点' : '添加站点'"
    :visible.sync="visibleTwo"
    @closed="closeTwo"
    :size="width<=720?'90%':'500px'"
    :with-header="true"
    class="box"
    :wrapperClosable="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="140px"
      class="demo-ruleForm"
    >
      <el-form-item label="上级站点" prop="parentId">
        <el-select
          @blur="hideParentClick"
          clearable
          filterable
          v-model="value"
          @change="selectChange"
          :popper-append-to-body="false"
          placeholder="请选择上级站点"
        >
          <el-option :value="mineStatusValue" style="height: auto">
            <el-tree
              :data="siteList"
              node-key="value"
              id="floatTree"
              ref="tree"
              :highlight-current="true"
              :default-expand-all="true"
              :current-node-key="currentKey"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
            >
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="站点名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入站点名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="后台名称" prop="manageName">
        <el-input
          v-model="ruleForm.manageName"
          placeholder="请输入站点管理后台显示名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="站点目录" prop="folder">
        <el-input
          v-model="ruleForm.folder"
          placeholder="请输入站点访问目录"
        ></el-input>
      </el-form-item>
      <el-form-item label="访问域名" prop="domain">
        <el-input
          v-model="ruleForm.domain"
          placeholder="请输入站点访问域名"
        ></el-input>
      </el-form-item>
       <el-form-item label="组织机构代码" prop="indexNumberCode">
        <el-input
          v-model="ruleForm.indexNumberCode"
          placeholder="请输入组织机构代码"
        ></el-input>
      </el-form-item>
      <el-form-item label="站点状态" prop="flagDisable">
        <div class="status">
          <el-radio v-model="ruleForm.flagDisable" label="0">启用</el-radio>
          <el-radio v-model="ruleForm.flagDisable" label="1">停用</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="站点描述" class="remark">
        <el-input
          :rows="4"
          type="textarea"
          placeholder="请输入站点描述"
          v-model="ruleForm.remark"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="btnShow" class="bottom">
        <div class="form-bottom">
          <el-button style="padding: 10px 24px" size="medium" @click="closeTwo"
            >取消</el-button
          >
          <el-button
            style="padding: 10px 24px"
            size="medium"
            type="primary"
            :loading="loading"
            @click="submit"
            >保存</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<script>
import { create, tree, update } from "./station_group_management";
import MonitorKeyboard from '@/utils/monitorKeyboard.js';
export default {
  data() {
    return {
      loading:false,
      visibleTwo:false,
      ruleForm: {
        parentId: "",
        name: "",
        domain: "",
        manageName: "",
        folder: "",
        remark: "",
        flagDisable: "",
        indexNumberCode:"",
      },
      rules: {
        parentId: [
          { required: true, message: "请选择上级站点", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入站点名称", trigger: "change" },
        ],
        domain: [
          { required: true, message: "请输入站点访问域名", trigger: "change" },
        ],
        manageName: [
          { required: true, message: "请输入站点管理后台显示名称", trigger: "change" },
        ],
        folder: [
          { required: true, message: "请输入站点访问目录", trigger: "change" },
        ],
        flagDisable: [
          { required: true, message: "请选择站点状态", trigger: "change" },
        ],
        indexNumberCode:[
           { required: true, message: "请输入组织机构代码", trigger: "blur" },
        ]
      },
      siteList: [],
      value: [],
      mineStatusValue: "",
      currentKey: "",
      width:'',
      btnShow:true,
    };
  },
  props: ["visible", "item", "tableData"],
  mounted() {},
  methods: {
    close() {
      this.$refs.ruleForm.clearValidate();
      this.$emit("close");
    },
     getKeyboardState(){
      let _this = this;
      this.monitorKeyboard = new MonitorKeyboard();
      this.monitorKeyboard.onStart();

      // 监听虚拟键盘弹出事件
      this.monitorKeyboard.onShow(() => {  
         _this.btnShow = false;
      })

      //监听键盘收起的事件
      this.monitorKeyboard.onHidden(() => {
         _this.btnShow = true;
      })
    },
    closeTwo(){
      this.$refs.ruleForm.clearValidate();
      this.$emit("closeTwo");
    },
    hideParentClick(e) {
      var isOther =
        e.relatedTarget == null ||
        e.relatedTarget.closest("div.el-tree") == null ||
        e.relatedTarget.closest("div.el-tree").id != "floatTree";

      if (isOther) {
        this.isShowSelect = false;
      } else {
        e.target.focus();
      }
    },
    selectChange(e) {
      // 针对输入框中改变的
    },
    handleNodeClick(data) {
      this.value = data.label;
      this.ruleForm.parentId = data.value;
    },
    submit() {
      this.loading = true;
       this.$refs.ruleForm.validate((valid) => {
         if(valid){
            if (this.item.id) {
        this.ruleForm.id = this.item.id;
        update(this.ruleForm).then((res) => {
          if (res.code == 0) {
            this.close();
          }
           this.loading = false;
        });
      } else {
        create(this.ruleForm).then((res) => {
          if (res.code == 0) {
            this.close();
          }
           this.loading = false;
        });
      }
         }else{
             this.loading = false;
         }
       })
      
    },
    getSiteList() {
      tree().then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/name/g, "label")
            .replace(/id/g, "value");
          this.siteList = JSON.parse(JSON.stringify(JSON.parse(options)));
          if (this.item.id) {
            this.$nextTick(() => {
              this.currentKey = this.item.parentId;
              this.$refs.tree.setCurrentKey(this.currentKey);
            });
          }
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
  },
  watch: {
    visible(val) {
      this.visibleTwo = val;
       this.getKeyboardState()
          this.width = document.documentElement.clientWidth;
                window.onresize = () => {
                    return (() => {
                        this.width  = document.documentElement.clientWidth;
                    })();
                    };
      if (this.visible) {
        // 请求站点列表
        this.getSiteList();
      }
      if (this.item.id) {
        this.ruleForm.parentId = this.item.parentId;
        this.ruleForm.name = this.item.name;
        this.ruleForm.domain = this.item.domain;
        this.ruleForm.manageName = this.item.manageName;
        this.ruleForm.folder = this.item.folder;
        this.ruleForm.remark = this.item.remark;
         this.ruleForm.indexNumberCode = this.item.indexNumberCode;
        this.ruleForm.flagDisable = `${this.item.flagDisable}`;
        this.value = this.item.parentName;
        this.ruleForm.parentId = this.item.parentId;
      } else {
        this.ruleForm = JSON.parse(
          JSON.stringify({
            parentId: "",
            name: "",
            domain: "",
            manageName: "",
            folder: "",
            remark: "",
            flagDisable: "",
            indexNumberCode:"",
          })
        );
      }
    },
  },
  created() {
    console.log(this.visible, "ssss");
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.demo-ruleForm {
  padding-right: 24px;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-form-item__label {
  text-align: left;
  padding-left: 22px;
}
.remard {
  text-indent: 10px;
}
/deep/ input::-webkit-input-placeholder {
  color: #415058;
}
/deep/ .ant-select-selection__placeholder {
  color: #415058;
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  height: 60px;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  .form-bottom {
    margin-top: 19px;
    margin-right: 24px;
  }
}
/deep/ .el-select .el-input .el-select__caret {
  color: #000;
}
.status {
  border: solid 1px #dcdfe6;
  border-radius: 4px;
  padding-left: 10px;
}
/deep/ .el-radio__inner::after {
  width: 8px;
  height: 8px;
}
/deep/ .el-radio__inner {
  width: 16px;
  height: 16px;
}
/deep/ .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
  background: #fff !important;
}
/deep/ .el-tree-node__label {
  font-weight: 500;
}
/deep/ .el-select-dropdown__empty{
  display: none;
}
/deep/ .el-select-dropdown__list{
  padding:12px 0 !important;
}
.el-button--primary {
  background: #176de6;
}
</style>